<div class="sd-layout-container">
  <mat-toolbar>
    <button mat-mini-fab (click)="toggleSideMenu()">
      <mat-icon> {{ (navService.showSideMenu$ | async) ? 'close' : 'menu' }} </mat-icon>
    </button>
    <sd-portal-app-user-info class="user-info"></sd-portal-app-user-info>
    <sd-portal-app-search class="top-search"></sd-portal-app-search>
    <sd-app-save class="save-btn"></sd-app-save>
    <button mat-mini-fab [matMenuTriggerFor]="appsettings">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #appsettings="matMenu" yPosition="below">
      <div *ngIf="enableAudit$ | async">
        <ng-container *ngIf="auditScreen$ | async as auditScreen">
          <button mat-menu-item (click)="showAudit(auditScreen)">
            <mat-icon>assignment</mat-icon>
            <span>Show {{ auditScreen }} Audit</span>
          </button>
        </ng-container>
        <ng-container *ngIf="auditScreens$ | async as auditScreens">
          <button
            *ngFor="let auditScreen of auditScreens"
            mat-menu-item
            (click)="showAudit(auditScreen)"
          >
            <mat-icon>assignment</mat-icon>
            <span>Show {{ auditScreen }} Audit</span>
          </button>
        </ng-container>
      </div>
      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </mat-toolbar>
  <mat-sidenav-container cdkScrollable>
    <mat-sidenav #sidenav mode="over" [opened]="showSiteMenu" (closedStart)="onSiteMenuClose()">
      <sd-side-nav></sd-side-nav>
    </mat-sidenav>
    <mat-sidenav-content>
      <sd-portal-audit
        *ngIf="enableAudit$ | async as enableAudit; else disableAudit"
        [selectedAuditScreen]="selectedAuditScreen$ | async"
      >
        <router-outlet></router-outlet>
      </sd-portal-audit>
      <ng-template #disableAudit>
        <router-outlet></router-outlet>
      </ng-template>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<sd-portal-csat-modal *ngIf="csatModalService.openModal$ | async"></sd-portal-csat-modal>

<sd-loader-global></sd-loader-global>
